// @ts-nocheck

export const loadSwiperSliderBeerInternal = () => {
  if (document.querySelector('#sliderBeerInternalSwiper')) {
    const swiper = new Swiper('#sliderBeerInternalSwiper', {
      slidesPerView: 1,
      navigation: {
        nextEl: '#sliderBeerInternalSwiper .swiper-button-next',
        prevEl: '#sliderBeerInternalSwiper .swiper-button-prev'
      }
    })
  }
}
